import React from 'react';
import clsx from 'clsx';
import DataModelsDropdown from './DataModelsDropdown';
import Events from '../../hooks/events';

const DatasetsDataModelFilter = ({ category, className, fluid }) => {
  const onChange = Events.useUpdateDatasetsDataModelFilter(category);
  return (
    <DataModelsDropdown
      className={clsx('aridhia-datasets-data-model-filter', 'aridhia-table-filter', className)}
      clearable
      entity="filter"
      fluid={fluid}
      onChange={onChange}
    />
  );
};

export default DatasetsDataModelFilter;
